import { MAINTENANCE_TYPES } from "../../core/constants/actionTypes";

export const rxSetIsUnderMaintenance = (payload) => ({
    type: MAINTENANCE_TYPES.RX_SET_IS_UNDER_MAINTENANCE,
    payload
});